<template>
    <div>
        <v-text-field
                v-model="formData.yearFounded"
                :counter="4"
                label="Year Founded"
                required
                :error-messages="yearFoundedErrors"
                @input="$v.formData.yearFounded.$touch()"
                @blur="$v.formData.yearFounded.$touch()"
        ></v-text-field>
        <v-text-field
                v-model="formData.size"
                label="Number of Employees"
                required
                :error-messages="sizeErrors"
                @input="$v.formData.size.$touch()"
                @blur="$v.formData.size.$touch()"
                hint="Must be a whole number e.g. ‘1’ not ‘one’"
                :persistent-hint="true"
        ></v-text-field>
        <v-radio-group
                v-model="formData.turnover"
                :error-messages="turnoverErrors"
                @input="$v.formData.turnover.$touch()"
                @blur="$v.formData.turnover.$touch()"
        >
            <div slot="label">Company Turnover</div>
            <v-radio label="Less than £1million" value="lt1m"></v-radio>
            <v-radio label="Between £1-5million" value="1mto5m"></v-radio>
            <v-radio label="More than £5million" value="gt5m"></v-radio>
        </v-radio-group>
    </div>
</template>

<script>
  import {FieldsMixin} from '@/forms/mixins'
  import {required, numeric, minValue, maxValue, minLength, maxLength, helpers} from 'vuelidate/lib/validators'

  export default {
    name: 'AboutUsFields',
    mixins: [FieldsMixin],
    data: () => ({
      formData: {
        yearFounded: null,
        size: null,
        turnover: null
      }
    }),
    validations: {
      formData: {
        yearFounded: {
          // TODO: validate that the year is not after current year
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4),
          validYearFounded: function (value) {
            const currentYear = new Date().getUTCFullYear()
            return value <= currentYear
          }
        },
        size: {
          numeric,
          required,
          minValue: minValue(1),
          maxValue: maxValue(2000000000)
        },
        turnover: {
          required
        }
      }
    },
    computed: {
      yearFoundedErrors () {
        const errors = []
        if (!this.$v.formData.yearFounded.$dirty) return errors
        !this.$v.formData.yearFounded.required && errors.push('Year founded is required.')
        !this.$v.formData.yearFounded.numeric && errors.push('Year founded must be a number.')
        !this.$v.formData.yearFounded.minLength && errors.push('Year founded must be 4 digits.')
        !this.$v.formData.yearFounded.maxLength && errors.push('Year founded must be 4 digits.')
        !this.$v.formData.yearFounded.validYearFounded && errors.push('Year founded cannot be in the future.')
        return errors
      },
      sizeErrors () {
        const errors = []
        if (!this.$v.formData.size.$dirty) return errors
        !this.$v.formData.size.required && errors.push('Company size is required.')
        !this.$v.formData.size.minValue && errors.push('There must be at least 1 employee in the company.')
        !this.$v.formData.size.maxValue && errors.push('The maximum number of employees is 2000000000 (even if you have more)')
        return errors
      },
      turnoverErrors () {
        const errors = []
        if (!this.$v.formData.turnover.$dirty) return errors
        !this.$v.formData.turnover.required && errors.push('Company turnover is required.')
        return errors
      }
    }
  }
</script>

<style scoped>

</style>
